import { render, staticRenderFns } from "./StepFork.vue?vue&type=template&id=5d2dd834&"
import script from "./StepFork.vue?vue&type=script&lang=js&"
export * from "./StepFork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports